import React from 'react';

/**
 * Renders a single row of icon + content (pills, text, etc).
 * Props:
 *  - Icon: a Lucide-react icon component
 *  - children: the content next to the icon
 *  - alignmentStatus: optional 'match' | 'mismatch' | null for visual indicator
 *  - testId: optional data-testid on the row. PillList's `idPrefix` is NOT a
 *    DOM id (TimedPill consumes it for tooltip state only), so a row carrying
 *    a name that must be told apart from a similar one beside it has no
 *    selector without this. The builder card's public-display-name and private
 *    facility rows are exactly that case.
 */
const InfoRow = ({ Icon, children, alignmentStatus = null, testId = undefined }) => {
  // Build CSS class with optional alignment indicator
  const alignmentClass = alignmentStatus === 'match'
    ? 'alignment-match'
    : alignmentStatus === 'mismatch'
      ? 'alignment-mismatch'
      : '';
  const rowClass = ['info-section', alignmentClass].filter(Boolean).join(' ');

  return (
    <div className={rowClass} data-testid={testId}>
      <Icon size={20} className="icon-inline" />
      {children}
    </div>
  );
};

export default InfoRow;

